const secondsToTime = (secs: number) => {
  if (secs < 0) {
    secs = secs * -1;
  }
  secs = Math.round(secs);

  let days = Math.floor(secs / (60 * 60 * 24));

  let divisor_for_hours = secs % (60 * 60 * 24);
  let hours = Math.floor(divisor_for_hours / (60 * 60));

  let divisor_for_minutes = secs % (60 * 60);
  let minutes = Math.floor(divisor_for_minutes / 60);

  let divisor_for_seconds = divisor_for_minutes % 60;
  let seconds = Math.ceil(divisor_for_seconds);

  let str = '';
  let c = 0;

  if (days > 0 && c < 2) {
    str += days + 'd ';
    c++;
  }
  if (hours > 0 && c < 2) {
    str += hours + 'h ';
    c++;
  }
  if (minutes > 0 && c < 2) {
    str += minutes + 'm ';
    c++;
  }
  if ((seconds > 0 && c < 2) || str.length === 0) {
    str += seconds + 's';
    c++;
  }

  return str.trim();
};

export default secondsToTime;
